import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { of, Subscription } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import * as _ from 'lodash';

import { AuthenticationModel } from 'src/app/authentication/authentication.model';
import { AutoUnsubscribe } from 'helpers';

@Component({
    selector: 'fc-verified-email',
    templateUrl: './verified-email.component.html',
    styleUrls: ['./verified-email.component.less'],
    standalone: false
})
@AutoUnsubscribe
export class SignupVerifiedEmailComponent implements OnInit {
    private _subscription$ = new Subscription();
    private _redirectionPath: string;

    constructor(
        private authenticationModel: AuthenticationModel,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this._subscription$.add(
            this.authService.user$
                .pipe(
                    switchMap((user) => {
                        // Includes AppUser user-metadata
                        return this.authenticationModel.getAppUser(user.sub).pipe(catchError(() => of(null)));
                    })
                )
                .subscribe((user) => {
                    this._redirectionPath = _.get(user, 'userMetadata.redirectionPath', '/');
                })
        );
    }

    continueSignup() {
        this._subscription$.add(
            this.authService
                .loginWithRedirect({
                    appState: {
                        target: this._redirectionPath
                    },
                    authorizationParams: {
                        screen_hint: this.getScreenHint(this._redirectionPath)
                    }
                })
                .subscribe()
        );
        return;
    }

    private getScreenHint(url: string): string | null {
        const match = url.match(/[?&]screen_hint=([^&]+)/);
        return match ? match[1] : 'login';
    }
}
